export default __webpack_public_path__ + "static/media/m-chikhirtma.da4fbfdd.png";